import { Theme } from '@easeltv/client-sdk';

/* --------------------------- defaultSectionTheme -------------------------- */

/**
 * defaultSectionTheme
 *
 * Default value for sections in defaultErrorTheme if the theme fails to load
 */
export const defaultSectionTheme: Theme['sections']['page'] = {
    luminance: {
        background: 'dark',
        feature: 'dark',
        featureMouseover: 'light',
        foreground: 'light',
    },
    a: '#FFFFFF',
    b: '#E8E8E8',
    background: '#222222',
    c: '#8B8B8B',
    d: '#3B3B3B',
    e: '#191919',
    feature: '#66943e',
    featureMouseover: '#93B973',
    featureMouseoverText: '#191919',
    featureText: '#FFFFFF',
};

/* ---------------------------- defaultErrorTheme --------------------------- */

/**
 * defaultErrorTheme
 *
 * Default theme to use if the theme fails to load
 */
export const defaultErrorTheme: Theme = {
    id: 'error-theme',
    sections: {
        light: '#FFFFFF',
        medium: '#A0A0A0',
        mediumLight: '#E2E2E2',
        dark: '#000000',
        negative: '#D30C2C',
        positive: '#74AA45',
        header: defaultSectionTheme,
        menu: defaultSectionTheme,
        page: defaultSectionTheme,
        footer: defaultSectionTheme,
        sideMenu: defaultSectionTheme,
        links: {},
    },
};
